import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { cancelLocationsOfCards } from '../api/rsimActionsApi.ts';

export const useRSimCancelLocationMutation = (
  options?: Omit<UseMutationOptions<void, Error, { euiccIds: string[] }, unknown>, 'mutationFn'>,
) => {
  return useMutation({
    ...options,
    mutationFn: (props) => {
      return cancelLocationsOfCards(props);
    },
  });
};
